/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiLastRunInfoResponseFromJSON, } from '../models';
/**
 *
 */
export class LastRunInfoServiceApi extends runtime.BaseAPI {
    /**
     */
    lastRunInfoServiceGetLastRunInfoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling lastRunInfoServiceGetLastRunInfo.');
            }
            if (requestParameters.type === null || requestParameters.type === undefined) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling lastRunInfoServiceGetLastRunInfo.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/lastrun/v1/projects/{projectId}/type/{type}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiLastRunInfoResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    lastRunInfoServiceGetLastRunInfo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lastRunInfoServiceGetLastRunInfoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
    * @export
    * @enum {string}
    */
export var LastRunInfoServiceGetLastRunInfoTypeEnum;
(function (LastRunInfoServiceGetLastRunInfoTypeEnum) {
    LastRunInfoServiceGetLastRunInfoTypeEnum["LAST_RUN_INFO_NAME_UNSPECIFIED"] = "LastRunInfoNameUnspecified";
    LastRunInfoServiceGetLastRunInfoTypeEnum["LAST_RUN_INFO_NAME_PAGEVIEWS"] = "LastRunInfoNamePageviews";
    LastRunInfoServiceGetLastRunInfoTypeEnum["LAST_RUN_INFO_NAME_GOOGLE_SYNC_UTC"] = "LastRunInfoNameGoogleSyncUTC";
    LastRunInfoServiceGetLastRunInfoTypeEnum["LAST_RUN_INFO_NAME_REFRESH_FACEBOOK_ENTITIES"] = "LastRunInfoNameRefreshFacebookEntities";
})(LastRunInfoServiceGetLastRunInfoTypeEnum || (LastRunInfoServiceGetLastRunInfoTypeEnum = {}));
